<template>
<div>
   <v-text-field data-aircraft="registrationNumber"
      v-model="aircraft.registrationNumber" 
      label="Aircraft Registration Number" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="make"
      v-model="aircraft.make" 
      label="Aircraft Make" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="model"
      v-model="aircraft.model" 
      label="Aircraft Model" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="serialNumber"
      v-model="aircraft.serialNumber" 
      label="Aircraft Serial Number" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="engineAmount"
      v-model="aircraft.engineAmount" 
      label="Aircraft Engine Amount" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="engineMake"
      v-model="aircraft.engineMake" 
      label="Aircraft Engine Make" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="engineModel"
      v-model="aircraft.engineModel" 
      label="Aircraft Engine Model" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="propellerAmount"
      v-model="aircraft.propellerAmount" 
      label="Aircraft Propeller Amount" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="propellerMake"
      v-model="aircraft.propellerMake" 
      label="Aircraft Propeller Make" 
      required>
   </v-text-field>
   <v-text-field data-aircraft="propellerModel"
      v-model="aircraft.propellerModel" 
      label="Aircraft Propeller Model" 
      required>
   </v-text-field>
</div>
</template>

<script>
export default {
  data: () => ({}),
  props: ["aircraft"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
